import { ContentContainerType } from 'types/enums';
import { Skeleton } from '@chakra-ui/react';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { LabelVersionDetailsFormGrid } from 'app/components/Releases/LabelVersionDetailsFormGrid';

export const LabelVersionFormLoader = () => (
  <ContentContainer
    type={ContentContainerType.FORM}
    isViewContent
    data-testid="version-details-loader"
  >
    <LabelVersionDetailsFormGrid
      altTitle={<Skeleton w="full" h="48px" />}
      artist={<Skeleton w="full" h="48px" />}
      genres={<Skeleton w="full" h="48px" />}
      keySignature={<Skeleton w="full" h="48px" />}
      timeSignature={<Skeleton w="full" h="48px" />}
      tempo={<Skeleton w="full" h="48px" />}
      duration={<Skeleton w="full" h="48px" />}
      language={<Skeleton w="full" h="48px" />}
      explicit={<Skeleton w="full" h="48px" />}
      location={<Skeleton w="full" h="48px" />}
    />
  </ContentContainer>
);
